// The operator's words for what a subagent can be given (pure; covered by
// blueprints.selftest.ts): a skill's slug "lattice-knowledge" reads
// "Knowledge", "lattice-pdf-report" "PDF report"; a knowledge library reads
// as the project that owns it, else its own name in words.

import { humanizeSlug, isLikelyAcronym } from "@/lib/format";

// Acronyms humanizeSlug's guess does not know (it keeps "pdf" lower case).
const ACRONYMS = new Set(["pdf", "api", "cc", "csv", "sql", "ai", "tts", "url"]);
const acronym = (w: string) => ACRONYMS.has(w) || isLikelyAcronym(w);

/** "lattice-knowledge" → "Knowledge", "lattice-pdf-report" → "PDF report", "my_tool" → "My tool". */
export function skillLabel(slug: string): string {
  const bare = slug.replace(/^lattice[-_]/, "");
  return humanizeSlug(bare, null, { acronyms: acronym }) || slug;
}

/** A library's name: its project's name when a project owns it, else the corpus name in words. */
export function libraryLabel(corpus: string, projectName?: string | null): string {
  const named = projectName?.trim();
  if (named) return named;
  return humanizeSlug(corpus, null, { titleCase: true }) || corpus;
}
